var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getAdditionalInfoVal } from '../getAdditionalInfoVal';
import { CARDS_INFO_KEY } from '../../constants/cards';
export var updateIsPayInCardsInfo = function (additionalInfo, isPay) {
    var cards = JSON.parse(getAdditionalInfoVal(additionalInfo, CARDS_INFO_KEY) || '[]') || [];
    return JSON.stringify((cards === null || cards === void 0 ? void 0 : cards.map(function (card) { return (__assign(__assign({}, card), { isPay: isPay })); })) || []);
};
//# sourceMappingURL=updateIsPayInCardsInfo.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getAdditionalInfoVal } from '../getAdditionalInfoVal';
import { CARDS_INFO_KEY } from '../../constants/cards';
export var updateIsPayInCardsInfo = function (additionalInfo, isPay) {
    var cards = JSON.parse(getAdditionalInfoVal(additionalInfo, CARDS_INFO_KEY) || '[]') || [];
    return JSON.stringify((cards === null || cards === void 0 ? void 0 : cards.map(function (card) { return (__assign(__assign({}, card), { isPay: isPay })); })) || []);
};
//# sourceMappingURL=updateIsPayInCardsInfo.js.map